import AutocompleteContainer from './components/AutocompleteContainer';
import AutocompleteFilterButton from './components/AutocompleteFilterButton';
import AutocompleteWithLabel from './components/AutocompleteWithLabel';
import type { BaseMultiAutocompleteProps } from './types';

function BaseMultiAutocomplete<T>(props: BaseMultiAutocompleteProps<T>) {
  return (
    <AutocompleteContainer>
      <AutocompleteWithLabel<T> {...props.autocomplete} />
      {props.actionButton && props.actionButton.buttonLabel && (
        <>
          <AutocompleteFilterButton
            buttonLabel={props.actionButton.buttonLabel}
            buttonRef={props.actionButton.buttonRef}
            onClick={() => props.actionButton && props.actionButton.onApply && props.actionButton.onApply(props.autocomplete.value)}
            isDisabled={props.autocomplete.disabled || !props.autocomplete.value || props.autocomplete.value.length === 0}
          />
        </>
      )}
    </AutocompleteContainer>
  );
}

export default BaseMultiAutocomplete as typeof BaseMultiAutocomplete;
